<template>
    <div class="priority-list-page">

        <v-container grid-list-md class="no-padding-top">
            <v-layout row wrap>

                <!-- @TODO THESE ARE questions, NOT symptoms!!! -->
                <!-- @TODO Must rename "symptom" to "question"!!! -->
                <v-flex v-for="symptom in selectedRelatedSymptomListPriority"
                        :ref="'vFlexQuestionRef_' + symptom.code"
                        :key="symptom.code"
                        :id="'Q_' + symptom.code"
                        @click="selectSymptom(symptom)"
                        class="symptom-priority"
                        :class="{
                            'selected-symptom':(symptom.code === symptomCode), 'symptom-response':(symptom.providedAnswer !== null ),
                            'panel-highlighted': shortcutNav.isKeyboardNav === true && shortcutNav.isPanelHighlight === true && shortcutNav.crtPanel === 'QUESTIONS_PANEL' && shortcutNav.crtQuestion === symptom.code
                        }"
                        sm12 md12 lg12
                >

                    <div>
                        <div>
                            <div>
                                  <span v-if="isAdmin && typeof symptom.decisionItemUpgrade !== 'undefined' && symptom.decisionItemUpgrade !== null" class="icon-decision-item">
                                    <arrow-up-di-upgrade-icon
                                        :color="getDecisionItemColor(symptom.decisionItemUpgrade)"
                                        :width="22"
                                        :height="22"
                                    ></arrow-up-di-upgrade-icon>
                                  </span>

                                <span v-if="getDecisionItem(symptom) !== null && getDecisionItem(symptom).icon === null"
                                      :style="{'color': getDecisionItemColor(getDecisionItem(symptom)) }"
                                >*</span>

                                <span v-if="getDecisionItem(symptom) !== null && getDecisionItem(symptom).icon !== null"
                                      class="icon-decision-item"
                                      v-html="getDecisionItem(symptom).icon.replace(/COLOR_PLACEHOLDER/gi, getDecisionItemColor(getDecisionItem(symptom)))"
                                >
                                </span>

                                <span :style="{'color': getDecisionItemColor(getDecisionItem(symptom)) }" class="question-title">
                                    <span v-if="symptom.symptomName" :id="'Q_SYMPTOM_NAME_' + symptom.code">{{symptom.symptomName}}: </span>
                                    <span :id="'Q_NAME_' + symptom.code">{{ symptom.name }}</span>
                                </span>
                            </div>
                            <div class="symptom-text">
                                <span :id="'Q_TEXT_' + symptom.code">{{symptom.text}}</span>
                            </div>
                        </div>

                        <v-layout :ref="'vLayoutQuestion_' + symptom.code + '_AnswerListPanelRef'" row wrap class="symptoms-list">

                                <div v-for="answer in symptom.answers"
                                     :key="answer.code"
                                     :ref="'divAnswerRef_' + answer.code"
                                     class="answers"
                                >

                                    <v-btn-toggle
                                        class="transparent"
                                        :class="{'button-highlighted': shortcutNav.isKeyboardNav === true
                                                                      && shortcutNav.isPanelHighlight === false
                                                                      && shortcutNav.crtPanel === 'QUESTIONS_PANEL'
                                                                      && shortcutNav.crtAnswer === answer.code}"

                                    >

                                        <v-btn
                                            @click="handleChangeAnswer(answer.code, symptom.code, symptom.answeredByVitalParam, $event)"
                                            :value="answer.code"
                                            :ref="'vBtn_' + symptom.code + '_' + answer.code"
                                            :id="'A_' + answer.code"
                                            :class="{'active':(symptom.providedAnswer === answer.code),  'active-symptom': isActive }"
                                            >{{answer.text}}
                                        </v-btn>
                                    </v-btn-toggle>

                               </div>
                        </v-layout>


                    </div>
                </v-flex>
            </v-layout>
        </v-container>

    </div>
</template>

<!-- ################################################################## -->

<script>
import SymptomQuestionItem from "../../../../common/components/shared/SymptomQuestionItem";
import {mapGetters} from 'vuex';
import RadialProgressSvg from "../../../../common/components/svg/productList/radialProgress";
import QuestionListBlock from "../../../../common/components/shared/QuestionListBlock";
import ArrowUpDiUpgradeIcon from "../../../../common/components/svg/shared/ArrowUpDiUpgradeIcon.vue";

export default {

        name: "SymptomsPriorityList",

        components: {
            SymptomQuestionItem,
            RadialProgressSvg,
            QuestionListBlock,
            ArrowUpDiUpgradeIcon
        },

        data () {
            return {
                isActive: false
            }
        },

        computed: {
            ...mapGetters({
                selectedRelatedSymptomListPriority: 'SymptomsQuestionsStore/getSelectedRelatedSymptomListPriority',
                symptomDescription: 'SymptomsQuestionsStore/getSymptomDescription',
                symptomCode: 'SymptomsQuestionsStore/getSymptomCode',
                answerCode: 'SymptomsQuestionsStore/getAnswerCode',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getIsThemeDarkActive : 'TranslationStore/getIsThemeDarkActive',
                getDecisionItemColor: 'ThemeStore/getDecisionItemColor',
                isAdmin: 'UserStore/getIsAdmin'
            }),

            navGetCrtQuestion() {
                return this.shortcutNav.crtQuestion;
            },

            getDecisionItem() {

                return (question) => {

                    const decisionItem = typeof question.decisionItem !== 'undefined' ? question.decisionItem : null;
                    const decisionItemUpgrade = typeof question.decisionItemUpgrade !== 'undefined' ? question.decisionItemUpgrade : null;

                    if (this.isAdmin) {
                        return decisionItem;
                    }
                    else {

                        if (decisionItem !== null && decisionItemUpgrade !== null) {

                            // If has decisionItem && decisionItemUpgrade => choose the highest DI1 (DI1.priority is lower)
                            if (decisionItemUpgrade.priorityLevel < decisionItem.priorityLevel) {
                                return decisionItemUpgrade;
                            }
                            else {
                                return decisionItem;
                            }
                        }
                        else if (decisionItem === null && decisionItemUpgrade !== null) {

                            return decisionItemUpgrade;
                        }
                        else if (decisionItem !== null && decisionItemUpgrade === null) {

                            return decisionItem;
                        }
                        else {
                            return null;
                        }
                    }
                }
            }
        },

        props: ["shortcutNav"],

        watch: {

            navGetCrtQuestion(newVal, oldVal) {

                if (this.shortcutNav.crtQuestion === null) {
                    return;
                }

                let questionIdx = this.selectedRelatedSymptomListPriority.findIndex((currentQuestion) => {
                    return this.shortcutNav.crtQuestion === currentQuestion.code;
                });

                if (questionIdx < 0) {
                    return;
                }

                let currentQuestion = this.selectedRelatedSymptomListPriority[questionIdx];
                // If the current question was pre-answered from VitalParametersDropdown the selectSymptom function was already called by the click event
                // This allows the VitalParameters to be closed after being opened
                if (currentQuestion.answeredByVitalParam !== null) {
                    return;
                }
                this.selectSymptom(currentQuestion);
            }

        },

        methods: {
            handleChangeAnswer (selectedAnswerCode, selectedQuestionCode, answeredByVitalParam, e) {

                if (answeredByVitalParam != null) {
                    this.$store.commit('VitalParametersStore/setMustShowVitalParamsForm', true);
                    this.$store.commit('VitalParametersStore/setFocusVitalParameter', answeredByVitalParam);

                    return;
                }

                const that = this;
                    if(this.isActive ||
                        e.target.parentElement.classList.contains('active') ||
                        e.target.classList.contains('active')) {
                        setTimeout(function(){

                            that.$store.dispatch('SymptomsQuestionsStore/submitSpecificQuestionAnswer', {
                                newProvidedAnswerCode: '',
                                questionCode: selectedQuestionCode

                            }).then((response) => { that.$emit('emitChangeAnswer', {questionCode: selectedQuestionCode}); });
                        }, 100)

                    } else {

                        setTimeout(function(){

                            that.$store.dispatch('SymptomsQuestionsStore/submitSpecificQuestionAnswer', {
                                newProvidedAnswerCode: selectedAnswerCode,
                                questionCode: selectedQuestionCode

                            }).then((response) => { that.$emit('emitChangeAnswer', {questionCode: selectedQuestionCode}); });

                        }, 100)


                        setTimeout(function() {
                            let responseQuestion = Array.from(document.getElementsByClassName('symptom-response'));

                            if(responseQuestion.length === 1 ) {
                                responseQuestion[0].classList.add('last-item');
                            };

                        }, 1500)

                    }

            },

            handleChangeAnswerFromPriorityPage(selectedQuestionCode, selectedAnswerCode, isAnswerAdded, answerList) {

                if (this.$refs['vBtn_' + selectedQuestionCode + '_' + selectedAnswerCode] != null
                    && this.$refs['vBtn_' + selectedQuestionCode + '_' + selectedAnswerCode][0] != null
                    && this.$refs['vBtn_' + selectedQuestionCode + '_' + selectedAnswerCode][0].$el != null
                    && this.$refs['vBtn_' + selectedQuestionCode + '_' + selectedAnswerCode][0].$el.classList != null) {

                    let vBtnAnswerElement = this.$refs['vBtn_' + selectedQuestionCode + '_' + selectedAnswerCode][0].$el;

                    if (isAnswerAdded === true) {

                        //When make one Answer with class 'active', remove the class from other if exists
                        answerList.forEach((answerItem) => {

                            let answerItemCode = answerItem.code;

                            if (this.$refs['vBtn_' + selectedQuestionCode + '_' + answerItemCode] != null
                                && this.$refs['vBtn_' + selectedQuestionCode + '_' + answerItemCode][0] != null
                                && this.$refs['vBtn_' + selectedQuestionCode + '_' + answerItemCode][0].$el != null
                                && this.$refs['vBtn_' + selectedQuestionCode + '_' + answerItemCode][0].$el.classList != null) {

                                let answerItemElement = this.$refs['vBtn_' + selectedQuestionCode + '_' + answerItemCode][0].$el;

                                if (answerItemElement.classList.contains('active')) {
                                    answerItemElement.classList.remove('active');
                                }
                            }
                        });

                        vBtnAnswerElement.classList.add('active');
                    }
                    else {
                        vBtnAnswerElement.classList.remove('active');
                    }
                }

                const that = this;
                setTimeout(function() {

                    that.$store.dispatch('SymptomsQuestionsStore/submitSpecificQuestionAnswer', {
                        newProvidedAnswerCode: isAnswerAdded === true ? selectedAnswerCode : '',
                        questionCode: selectedQuestionCode

                    }).then((response) => { that.$emit('emitChangeAnswer', {questionCode: selectedQuestionCode}); });

                }, 100);

                setTimeout(function() {
                    let responseQuestion = Array.from(document.getElementsByClassName('symptom-response'));

                    if(responseQuestion.length === 1 ) {
                        responseQuestion[0].classList.add('last-item');
                    }

                }, 1500);
            },

            selectSymptom(symptom) {
                this.$store.commit('SymptomsQuestionsStore/setSymptomDescription', symptom.description);
                this.$store.commit('SymptomsQuestionsStore/setSymptomCode', symptom.code);
                this.$store.commit('SymptomsQuestionsStore/setSymptomName', symptom.name);
                this.$store.commit('SymptomsQuestionsStore/setSymptomText', symptom.text);
                this.$store.commit('SymptomsQuestionsStore/setRelatedSymptomName', symptom.symptomName);

                this.$emit('emitQuestionClick', {
                    questionCode: symptom.code
                });

            }

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .priority-list-page {

        .selected-symptom {
            -webkit-box-shadow: -8px 6px 33px -12px rgba(0, 0, 0, 0.75);
            -moz-box-shadow: -8px 6px 33px -12px rgba(0, 0, 0, 0.75);
            box-shadow: -8px 6px 33px -12px rgba(0, 0, 0, 0.75);
        }

        .question-title {
            font-size: $font-size-default;
            color: $color-headings-text;
        }

        .question-text {
            // SMASSDEV - 1119
            font-size: $font-size-small;
            // word-spacing: $word-spacing-small;
            // line-height: $line-height-small;
            // letter-spacing: $letter-spacing-small;
            color: $color-body-text;
        }
    }

</style>




// WEBPACK FOOTER //
// src/professional/components/symptoms-questions/symptoms-priority-list/SymptomsPriorityList.vue